module.exports = __webpack_public_path__ + "static/media/sun-riseaura-PH1_2.c66fe0a2.webp";